import React from 'react'
import { CoreLink } from 'common/CoreLink'
import styles from './PopoverLinkMenu.scss'
import { PopoverMenu, PopoverMenuItem, PopoverMenuHeading } from 'common/styleguide/PopoverMenu'
import cx from 'classnames'

export class PopoverLinkMenu extends React.PureComponent {
  render () {
    const { children, slim, disabled, ...props } = this.props
    return (
      <PopoverMenu className={cx(styles.PopoverLinkMenu, slim && styles.slim, disabled && styles.disabled)} {...props}>
        {children}
      </PopoverMenu>
    )
  }
}

export const PopoverLinkMenuItem = ({ to, href, children, ...props }) => (
  <PopoverMenuItem className={styles.PopoverLinkMenuItem}>
    <CoreLink to={to} href={href} {...props}>{children}</CoreLink>
  </PopoverMenuItem>
)

export const PopoverLinkMenuHeading = PopoverMenuHeading
